<div class="card mb-3 border-0 shadow-sm">
  <div class="card-header bg-info text-dark d-flex align-items-center gap-2">
    <i class="bx bx-plus-medical bx-sm"></i>
    <strong>Procedimientos</strong>
    <span class="badge bg-dark ms-auto">{{ procedures().length }}</span>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-sm table-bordered mb-0">
        <thead class="table-light">
          <tr>
            <th>Nombre</th>
            <th>Código CUPS</th>
            <th>Fecha Realización</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          @for (proc of procedures(); track proc.id) {
            <tr>
              <td>{{ getProcedureName(proc) }}</td>
              <td>
                @if (getProcedureCode(proc)) {
                  <code class="small">{{ getProcedureCode(proc) }}</code>
                } @else {
                  <span class="text-muted">—</span>
                }
              </td>
              <td>{{ formatDate(getPerformedDate(proc)) }}</td>
              <td>
                @let badge = getStatusBadge(proc.status || '');
                <span class="badge {{ badge.color }}">{{ badge.label }}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
